import React from 'react';
import { format } from 'date-fns';
import { useFormContext } from 'react-hook-form';
import { PlainText } from '@td-client-frontend/common';

export const MultiEditCodes = () => {
  const { getValues } = useFormContext();
  const [editCodes, checkedCodes] = getValues(['editCodes', 'checkedCodes']);

  return (
    <div className="overflow-auto max-h-64">
      {editCodes
        .filter(({ code }) => checkedCodes.includes(code))
        .map(({ code, start_dt, end_dt }) => {
          return (
            <div key={code} className="grid grid-cols-12 gap-x-4 border-b-1 border-gray px-2">
              <PlainText value={code} className="col-span-4 py-5" />
              <PlainText
                value={start_dt && format(start_dt, 'MM/dd/yyyy')}
                className="col-span-3 pt-3"
                placeholder="MM/DD/YYYY"
              />
              <PlainText
                value={end_dt && format(end_dt, 'MM/dd/yyyy')}
                className="col-span-3 pt-3"
                placeholder="MM/DD/YYYY"
              />
            </div>
          );
        })}
    </div>
  );
};
